export const handleLocationChange = (store) => (next) => (action) => {
  const { type, payload } = action;
  if (type === "ROUTER_PUSH") {
    window.scrollTo(0, 0);
  }

  if (type === "ROUTER_LOCATION_CHANGED") {
    const { result = {} } = payload;
    const { title = "" } = result;
    if (title) {
      document.title = title;
    }
    const menuToggle = document.getElementById("menu_toggle");
    if (menuToggle) {
      menuToggle.checked = false;
    }
  }
  next(action);
};



// WEBPACK FOOTER //
// ./src/middleware/index.js